const HEAT_TIME_PATTERN = /^(?:(\d+):)?(\d{1,2})(?:[.,](\d{1,2}))?$/;

export function normalizeHeatTimeInput(value) {
  const raw = String(value ?? "").trim();
  if (!raw) return "";

  const match = raw.match(HEAT_TIME_PATTERN);
  if (!match) return null;

  const [, minutesPart, secondsPart, hundredthsPart] = match;
  const seconds = Number(secondsPart);
  if (!Number.isFinite(seconds)) return null;

  if (minutesPart != null) {
    if (seconds > 59) return null;
    const minutes = String(Number(minutesPart));
    const normalizedSeconds = String(seconds).padStart(2, "0");
    const normalizedHundredths = hundredthsPart
      ? `.${String(hundredthsPart).padEnd(2, "0").slice(0, 2)}`
      : "";
    return `${minutes}:${normalizedSeconds}${normalizedHundredths}`;
  }

  const normalizedHundredths = hundredthsPart
    ? `.${String(hundredthsPart).padEnd(2, "0").slice(0, 2)}`
    : "";
  return `${String(seconds)}${normalizedHundredths}`;
}

export function isValidHeatTimeInput(value) {
  if (String(value ?? "").trim() === "") return true;
  return normalizeHeatTimeInput(value) !== null;
}

export function formatHeatTimeDisplay(value) {
  const normalized = normalizeHeatTimeInput(value);
  if (normalized === null) return String(value ?? "").trim();
  return normalized;
}

export function parseHeatTimeParts(value) {
  const normalized = normalizeHeatTimeInput(value);
  if (!normalized) {
    return {
      hasValue: false,
      minutes: 0,
      seconds: 0,
      hundredths: 0,
    };
  }

  const [timePart, hundredthsPart = "00"] = normalized.split(".");
  if (timePart.includes(":")) {
    const [minutesPart, secondsPart] = timePart.split(":");
    return {
      hasValue: true,
      minutes: Number(minutesPart || 0),
      seconds: Number(secondsPart || 0),
      hundredths: Number(hundredthsPart || 0),
    };
  }

  return {
    hasValue: true,
    minutes: 0,
    seconds: Number(timePart || 0),
    hundredths: Number(hundredthsPart || 0),
  };
}

export function buildHeatTimeFromParts({ hasValue = true, minutes = 0, seconds = 0, hundredths = 0 } = {}) {
  if (!hasValue) return "";

  const safeMinutes = Math.max(0, Number(minutes) || 0);
  const safeSeconds = Math.max(0, Math.min(59, Number(seconds) || 0));
  const safeHundredths = Math.max(0, Math.min(99, Number(hundredths) || 0));

  if (safeMinutes > 0) {
    return `${safeMinutes}:${String(safeSeconds).padStart(2, "0")}.${String(safeHundredths).padStart(2, "0")}`;
  }

  return `${safeSeconds}.${String(safeHundredths).padStart(2, "0")}`;
}
